/**
 * Bokja Size & Fit drawer — cm/in unit toggle.
 *
 * Flips data-unit on the table body; CSS shows/hides the matching cm vs inch
 * spans. The region highlight is server-rendered (data-region from
 * localization.country), so it needs no JS. Open/close/focus-trap come from the
 * shared fabric-drawer-component (Horizon DialogComponent). Delegated listener so
 * it works on swap-reached PDPs where the drawer enters the DOM after load.
 */
(() => {
  if (window.__bokjaSizeFitBound) return;
  window.__bokjaSizeFitBound = true;

  document.addEventListener('click', (event) => {
    const target = /** @type {HTMLElement} */ (event.target);
    const btn = target.closest('[data-sizefit-unit-toggle] button[data-unit]');
    if (!btn) return;

    const toggle = btn.closest('[data-sizefit-unit-toggle]');
    const body = btn.closest('[data-sizefit-body]');
    if (!toggle || !body) return;

    const unit = btn.getAttribute('data-unit');
    body.setAttribute('data-unit', unit);

    toggle.querySelectorAll('button[data-unit]').forEach((b) => {
      const isActive = b === btn;
      b.classList.toggle('is-active', isActive);
      b.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  });
})();
